<template>
    <ValidationProvider
        :mode="validationMode"
        :name="label || name || 'unknown'"
        :rules="rules"
        :vid="uniqueId"
        slim
        v-slot="{ validated, valid, errors }"
    >
        <rkm-form-group
            :class="['form-group-radio', {'placeholder-label': label === false }, { 'm-0': !label }, { 'mt-1': centerInput }]"
            :invalid-feedback="errors[0]"
            :label="label + (rules && rules.required ? ' *' : '')"
            :state="rules ? (validated ? valid : null) : null"
        >
            <div
                :class="{ inline, 'ml-2': inline }"
                class="mt-1"
            >
                <b-form-radio-group
                    :button-variant="buttonColor"
                    :buttons="buttons"
                    :checked="checked"
                    :class="{ 'form-group-radio-button-disabled': buttons && disabled }"
                    :disabled="disabled"
                    :options="options"
                    :stacked="stacked"
                    :state="rules ? (validated ? valid : null) : null"
                    :text-field="textField"
                    :value-field="valueField"
                    @change="$emit('change', $event)"
                    @input="$emit('input', $event)"
                >
                    <slot />
                </b-form-radio-group>
            </div>
        </rkm-form-group>
    </ValidationProvider>
</template>

<script>
// Components.
import {BFormRadioGroup} from 'bootstrap-vue'
import {ValidationProvider} from 'vee-validate'

// Mixins.
import {string} from './../mixins'

export default {
    components: {BFormRadioGroup, ValidationProvider},
    computed: {
        rules() {
            return this.disabled ? null : this.validations
        },
    },
    mixins: [string],
    model: {
        event: 'change',
        prop: 'checked',
    },
    props: {
        buttonColor: {type: String},
        buttons: {type: Boolean},
        centerInput: {type: Boolean},
        checked: {type: [Number, String, Boolean]},
        disabled: {type: Boolean},
        inline: {type: Boolean},
        label: {type: [String, Boolean], default: ''},
        name: {type: String},
        options: {type: [Array, Object]},
        stacked: {type: Boolean},
        textField: {type: String, default: 'nome'},
        validationMode: {type: String, default: 'lazy'},
        validations: {type: Object},
        valueField: {type: String, default: 'id'},
    }
}
</script>

<style scoped>
.inline {
    display: inline;
}
</style>